import { render } from "./LoginVue.vue?vue&type=template&id=5152f01b"
import script from "./LoginVue.vue?vue&type=script&lang=js"
export * from "./LoginVue.vue?vue&type=script&lang=js"

import "./LoginVue.vue?vue&type=style&index=0&id=5152f01b&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__